<div class="row">
  <loading-spinner [isLoading]="orderDetailService.loading" [classesString]="'top-50'"></loading-spinner>
  @if (!orderDetailService.loading) {
    <div class="col-12 col-md-6 mx-auto">
      <div class="card">
        @if (invoiceAddresses?.length > 1) {
          <modal-address-choose
            [addresses]="invoiceAddresses"
            (onSelectedAddress)="selectAddress($event, 'invoice')"
          ></modal-address-choose>
        }
        <div class="card-title mb-3">
          <h3>{{ 'address.invoice' | translate }}</h3>
        </div>
        <div class="card-text">
          <address-form
            [address]="orderDetailService.order.invoiceAddress"
            (addressChange)="
              orderDetailService.order.invoiceAddress = $event; orderDetailService.isEditedAddress = true
            "
          ></address-form>
          @if (shouldShowStoreAddressOnCustomerToggle()) {
            <div class="row mt-3">
              <div class="col-12">
                <form-row-toggle
                  [label]="'address.storeOnCustomer'"
                  [model]="orderDetailService.storeInvoiceAddressOnCustomer"
                  (modelChange)="orderDetailService.storeInvoiceAddressOnCustomer = $event"
                  [cursorPointer]="true"
                  [classesString]="'text-nowrap'"
                  [dataCyAttribute]="'store-invoice-address-on-customer'"
                ></form-row-toggle>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!orderDetailService.loading) {
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="card-title">
              <h3>{{ 'address.shipping' | translate }}</h3>
            </div>
            @if (shippingAddresses?.length && !orderDetailService.isShippingAddressSameAsInvoice) {
              <modal-address-choose
                [addresses]="shippingAddresses"
                (onSelectedAddress)="selectAddress($event, 'shipping')"
              ></modal-address-choose>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <form-row-toggle
              [label]="'address.same'"
              [model]="orderDetailService.isShippingAddressSameAsInvoice"
              (modelChange)="invoiceShippingRelationChange($event)"
              [cursorPointer]="true"
              [classesString]="'text-nowrap'"
              [dataCyAttribute]="'toggle'"
            ></form-row-toggle>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            @if (!orderDetailService.isShippingAddressSameAsInvoice) {
              <address-form
                [address]="orderDetailService.order.shippingAddress"
                (addressChange)="
                  orderDetailService.order.shippingAddress = $event; orderDetailService.isEditedAddress = true
                "
              ></address-form>
            }
            @if (!orderDetailService.isShippingAddressSameAsInvoice && shouldShowStoreAddressOnCustomerToggle()) {
              <div class="row mt-3">
                <div class="col-12">
                  <form-row-toggle
                    [label]="'address.storeOnCustomer'"
                    [model]="orderDetailService.storeShippingAddressOnCustomer"
                    (modelChange)="orderDetailService.storeShippingAddressOnCustomer = $event"
                    [cursorPointer]="true"
                    [classesString]="'text-nowrap'"
                    [dataCyAttribute]="'store-shipping-address-on-customer'"
                  ></form-row-toggle>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
